export const ERROR_MESSAGE = [
  {
    code: '302',
    message: 'システムエラーが発生しました',
    title: 'システムエラーが発生しました',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'できるだけ早くご覧いただけるよう、ただいま復旧に取り組んでおります。',
    description_3: '　　　　　　　　　　　',
    description_4: '同様の操作を再度くり返しても改善されない場合、お手数ですが弊社メンテナンスマンまで',
    description_5: 'お問い合わせください。',
  },
  {
    code: '400',
    message: 'システムエラーが発生しました',
    title: 'システムエラーが発生しました',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'できるだけ早くご覧いただけるよう、ただいま復旧に取り組んでおります。',
    description_3: '　　　　　　　　　　　',
    description_4: '同様の操作を再度くり返しても改善されない場合、お手数ですが弊社メンテナンスマンまでお問い合わせください。',
    description_5: '',
  },
  {
    code: '401',
    message: 'システムエラーが発生しました',
    title: 'システムエラーが発生しました',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'できるだけ早くご覧いただけるよう、ただいま復旧に取り組んでおります。',
    description_3: '　　　　　　　　　　　',
    description_4: '同様の操作を再度くり返しても改善されない場合、お手数ですが弊社メンテナンスマンまでお問い合わせください。',
    description_5: '',
  },
  {
    code: '403',
    message: 'システムエラーが発生しました',
    title: 'システムエラーが発生しました',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'できるだけ早くご覧いただけるよう、ただいま復旧に取り組んでおります。',
    description_3: '　　　　　　　　　　　',
    description_4: '同様の操作を再度くり返しても改善されない場合、お手数ですが弊社メンテナンスマンまでお問い合わせください。',
    description_5: '',
  },
  {
    code: '404',
    message: 'システムエラーが発生しました',
    title: 'システムエラーが発生しました',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'できるだけ早くご覧いただけるよう、ただいま復旧に取り組んでおります。',
    description_3: '　　　　　　　　　　　',
    description_4: '同様の操作を再度くり返しても改善されない場合、お手数ですが弊社メンテナンスマンまでお問い合わせください。',
    description_5: '',
  },
  {
    code: '408',
    message: '通信エラーが発生しました',
    title: '通信エラーが発生しました',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'インターネット接続状況をご確認いただき、ページの再読み込みをお試しください。',
    description_3: '　　　　　　　　　　　',
    description_4: 'インターネット接続状況を確認してもこのエラーが発生する場合、お手数ですが弊社メンテナンスマンまでお問い合わせください。',
    description_5: '',
  },
  {
    code: '500',
    message: 'システムエラーが発生しました',
    title: 'システムエラーが発生しました',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'できるだけ早くご覧いただけるよう、ただいま復旧に取り組んでおります。',
    description_3: '　　　　　　　　　　　',
    description_4: '同様の操作を再度くり返しても改善されない場合、お手数ですが弊社メンテナンスマンまでお問い合わせください。',
    description_5: '',
  },
  {
    code: '503',
    message: 'ただいまシステムメンテナンス中です',
    title: 'ただいまシステムメンテナンス中です',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'できるだけ早くご覧いただけるよう、ただいま復旧に取り組んでおります。',
    description_3: '　　　　　　　　　　　',
    description_4: '同様の操作を再度くり返しても改善されない場合、お手数ですが弊社メンテナンスマンまでお問い合わせください。',
  },
  {
    code: '-1',
    message: 'システムエラーが発生しました',
    title: 'システムエラーが発生しました',
    description_1: 'ご迷惑をおかけして申し訳ありません。',
    description_2: 'できるだけ早くご覧いただけるよう、ただいま復旧に取り組んでおります。',
    description_3: '　　　　　　　　　　　',
    description_4: '同様の操作を再度くり返しても改善されない場合、お手数ですが弊社メンテナンスマンまでお問い合わせください。',
    description_5: '',
  },
  {
    code: '999',
    message: '入力項目に誤りがあります。ご確認の上、正しく入力しなおしてください。',
    title: '　　　　　　　　　　　',
    description_1: '　　　　　　　　　　　',
    description_2: '　　　　　　　　　　　',
    description_3: '　　　　　　　　　　　',
    description_4: '　　　　　　　　　　　',
    description_5: '　　　　　　　　　　　'
  },
];

export default ERROR_MESSAGE;
